import React, { useCallback, useContext } from 'react';
import _ from 'underscore';
import {
  Settings16Regular,
  PersonAccounts20Regular,
  Payment20Regular,
  Tag20Regular
} from '@fluentui/react-icons';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { Menu, MenuTrigger, MenuButton, MenuItem, MenuList, MenuPopover } from '@fluentui/react-components';

const getStyles = () => ({
  menu: {
    position: 'fixed',
    top: 27,
    right: 43,
  },
  menuItem: {
    '& .fui-MenuItem__content': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  menuItemIcon: {
    marginRight: 4,
  },
});

const getRedirectUrl = (
  pageName: 'accountDetail' | 'payment' | 'coupon',
  rootUIUrl: string,
  { cid, aid, uid }: {cid: string, aid: string, uid: string}
) => {
  const search = `cid=${cid}&uid=${uid}&aid=${aid}`;
  switch (pageName) {
    case 'accountDetail':
      return `${rootUIUrl}cc/Settings/Account?${search}`;
    case 'payment':
      return `${rootUIUrl}cc/PaymentMethods?${search}`;
    case 'coupon':
      return `${rootUIUrl}cc/Billing/CouponDetails?${search}`;
    default:
      return '';
  }
};

export const ManageAccountMenu: React.FC<{}> = React.memo(() => {
  const i18n = useContext(I18nContext) as any;
  const classes = useDefaultStyles(getStyles);
  const serverContext = useContext(ServerContext);
  const { scope }: any = useContext(ScopeContext);
  const { aid, cid, uid } = scope.values;
  const RootUIUrl = _.get(serverContext, ['Urls', 'RootUIUrl'], '/');
  const onAccountDetailClick = useCallback(() => {
    window.open(getRedirectUrl('accountDetail', RootUIUrl, { aid, cid, uid }));
  }, [RootUIUrl, aid, cid, uid]);
  const onPaymentClick = useCallback(() => {
    window.open(getRedirectUrl('payment', RootUIUrl, { aid, cid, uid }));
  }, [RootUIUrl, aid, cid, uid]);
  const onCouponClick = useCallback(() => {
    window.open(getRedirectUrl('coupon', RootUIUrl, { aid, cid, uid }));
  }, [RootUIUrl, aid, cid, uid]);

  return (
    <Menu>
      <MenuTrigger>
        <MenuButton className={classes.menu} appearance="subtle" icon={<Settings16Regular />}>
          {i18n.getString(_TL_('Manage account'))}
        </MenuButton>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem className={classes.menuItem} onClick={onAccountDetailClick}>
            <PersonAccounts20Regular className={classes.menuItemIcon} />
            <span>{i18n.getString(_TL_('Edit account details'))}</span>
          </MenuItem>
          <MenuItem className={classes.menuItem} onClick={onPaymentClick}>
            <Payment20Regular className={classes.menuItemIcon} />
            <span>{i18n.getString(_TL_('Edit payment'))}</span>
          </MenuItem>
          <MenuItem className={classes.menuItem} onClick={onCouponClick}>
            <Tag20Regular className={classes.menuItemIcon} />
            <span>{i18n.getString(_TL_('View Coupon details'))}</span>
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
});
